<template>
    <!-- <div :class="['page survey',{ off: !pageOn }]"> -->

        <div :class="['page survey']"> 
        <!-- <VHeader type="back" @back="pageOn = false;" /> -->
        <Ham :on="on" @select="hamSelect" />
        <VHeader type="ham" @ham="on = true;" />
        <div class="page-content">
            <div class="ad-img" v-for="page in survey.pages">
                <div v-if="survey.loyalty" :class="['loyalty-ad-container',{ rotate: page.rotated }]">
                    <!-- <img class="sizer" :src="page.background"/> 
                    <div class="front-box"> -->
                    <div class="front-box" style="position: relative;">    
                        <img class="loyalty-ad" :src="page.background" style="position: relative" />
                        <div class="btns" :style="btnsStyle">
                            <div @click="btnClick(page,btn,$event)" @touchstart="btnTouch(page,btn)" v-for="btn in page.btns.filter(b => !b.reverse)" :class="['btn',{ selected: btn.selected },'type-'+btn.content.action]" :style="btn.content.style+';font-size:28px;display:flex;align-items:center;justify-content:space-around;'+( page.styleButton ? (';background-color:'+campaign.buttonColor+';color:'+campaign.buttonFontColor) : '')">
                                <a v-if="btn.content.type == 'phone'" :href="'tel:'+btn.content.value"></a>
                                <img class="qr-btn" v-if="btn.type == 'qr'" :src="'https://api.survey-vip.com/qr?id='+encodeURIComponent('https://loyalty-vip.com/redeem?cam='+survey.id+'&'+query+'&b='+btn.code+'&p='+page.code)" />
                                <img v-if="btn.type == 'gif'" :src="btn.content.gif" :style="btn.content.style" />
                            </div>
                        </div>
                    </div>
                    <div class="back-box">
                        <img class="loyalty-ad" :src="page.backFaceImage" />
                        <div class="btns" :style="btnsStyle">
                            <div @click="btnClick(page,btn)" v-for="btn in page.btns.filter(b => b.reverse)" :class="['btn',{ selected: btn.selected },'type-'+btn.content.action]" :style="btn.content.style+';font-size:28px;display:flex;align-items:center;justify-content:space-around;'+( page.styleButton ? (';background-color:'+campaign.buttonColor+';color:'+campaign.buttonFontColor) : '')">
                                <img class="qr-btn" v-if="btn.type == 'qr'" :src="'https://api.survey-vip.com/qr?id='+encodeURIComponent('https://loyalty-vip.com/redeem?s='+survey.id+'&c='+customerID+'&p='+page.code+'&i='+iss)+'&d='+page.date" />
                                <img v-if="btn.type == 'gif'" :src="btn.content.gif" :style="btn.content.style" />
                            </div>
                        </div>    
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import { mapActions, mapMutations } from 'vuex'
import WebSoc from '@/utils/WebSoc.js'
import Ham from '@/components/Ham.vue'

export default {
    name: 'survey',
    mixins: [ pageOn ],
    components: {
        VHeader,
        Ham
    },
    computed: {
        survey () { return this.$store.state.survey },
        query () { return this.$store.state.query },
        Query () { return this.$store.state.Query },
        iss () { return this.$store.state.iss },
        customer_id () { return this.$store.state.customer_id },
        customerID () { return this.$store.state.customerID }
    },
    data () {
        return {
            on: false,
            btnsStyle: '',
            date: Date.now()
        }
    },
    mounted () {
        this.btnsStyle = 'transform: scale('+( ( parseInt(getComputedStyle(this.$el.querySelector('.page-content')).width) - 10 ) / 414 )+')';
        console.log('mounted this.survey',this.survey);
    },
    methods: {
        hamSelect ( page ) {
            console.log('page',page);
            this.on = false;
            page && this.pushPage(page);
            if ( page == 'terms' ) {
                this.$emit('showTerms');
            }
        },
        btnTouch ( page, btn ) {
            console.log('btnTouch page',page);
            console.log('btnTouch btn',btn);
        },
        btnClick ( page, btn, e ) {

            var action = btn.content.action;

            WebSoc.SEND({ t: 'recordClick', data: { survey_id: this.survey._id, iss: this.iss, customer_id: this.customer_id, ad_id: page.ad_id, pageCode: page.code, btnCode: btn.code, type: btn.type }});
            
            var Service = {
                rotate: ( page, btn ) => { 

                    var qr = page.btns.find(b => b.type == 'qr' && b.reverse);

                    //if ( !qr ) return;

                    var data = { survey_id: this.survey._id, customer_id: this.customer_id, ad_id: page.ad_id, pageCode: page.code, QrBtnCode: qr && qr.code, iss: this.iss }
                    
                    if ( !page.rotated ) {
                        console.log('page',JSON.parse(JSON.stringify(page)));
                        console.log('btn',JSON.parse(JSON.stringify(btn)));

                        var survey = this.survey;
                        var query = this.query;
                        var date = Date.now();
                        var customerID = this.customerID;
                        var iss = this.iss;

                                  "'https://api.survey-vip.com/qr?id='+encodeURIComponent('https://loyalty-vip.com/redeem?s='+survey.id+'&c='+customerID+'&p='+page.code+'&i='+iss)+'&d='+page.date"

                        var link = 'https://api.survey-vip.com/qr?id='+encodeURIComponent('https://loyalty-vip.com/redeem?s='+survey.id+'&c='+customerID+'&p='+page.code+'&i='+iss+'&d='+date);

                        var data = decodeURIComponent(link.split('?')[1]).split('id=')[1].split('?')[1].split('&').reduce((p,d) => { p[d.split('=')[0]] = d.split('=')[1]; return p },{})
                        console.log('data',JSON.stringify(data,null,1));
                        console.log('link',decodeURIComponent(link.split('?')[1]));

                        this.$el.querySelectorAll('img.qr-btn').forEach(img => {
                            console.log('img ',decodeURIComponent(img.src.split('?')[1]));
                        })

                        //var data = { survey_id: this.survey._id, customer_id: this.customer_id, ad_id: page.ad_id, pageCode: page.code, QrBtnCode: qr.code, iss: this.iss }
                        console.log('qr',qr);
                        qr &&  WebSoc.SEND({ t: 'viewedCoupon', data },resp => {
                            console.log('resp',resp);
                            page.sent_id = resp.sent_id;
                            page.adIndex = resp.adIndex;
                            console.log('page..',JSON.parse(JSON.stringify(page)))
                            var interval = setInterval(() => {
                                if ( page.rotated ) { this.setKeyValue({ item: page, k: 'date', v: Date.now() }); } else { clearInterval(interval); }
                            },1000);
                        });
                    } else {
                        
                        data.sent_id = page.sent_id;
                        data.adIndex = page.adIndex;

                        WebSoc.SEND({ t: 'viewedCouponStop', data },resp => {
                            console.log('stopped view coupon',resp);
                        });
                    }

                    this.setKeyValue({ item: page, k: 'rotated', v: !page.rotated }) 
                },
                terms: ( page, btn ) => this.$emit('showSurveyTerms',btn.terms_id),
                link: ( page, btn ) => {
                    var link = btn.content.value;
                    if ( btn.type == 'link' ) {
                        window.open(link.indexOf('http') == -1 ? 'http://'+link : link);
                    }
                    if ( btn.type == 'phone' ) {
                        console.log('phone..')
                    }
                }
            }
            if ( typeof Service[action] == 'function' ) return Service[action](page, btn);
            console.log('what with',action);
            console.log(Object.keys(Service));

        },
        ...mapMutations([
            'pushPage'
        ]),
        ...mapMutations([
            'setKeyValue'
        ])
    }
}

</script>

<style lang="scss">
.page.survey {
    .page-content {
        background-color: white;
        height: calc(100% - 40px);
        .ad-img:last-child {
            .loyalty-ad-container {
                margin-bottom: 200px;
            }
        }
    }
}    
div.loyalty-ad-container {
    position: relative;
    transition: transform 1s;
    -webkit-perspective: 1000;
    transform-style: preserve-3d;
    perspective: 1000;
    -webkit-transform:translate3d(0,0,0);
    float: left;
    width: calc(100% - 10px);
    margin: 5px 0px 0px 5px;
    img.sizer {
        width: 100%;
        margin: 0px;
        z-index: -1;
        opacity: 0;
    }
    .front-box,.back-box {
        float: left;
        opacity: 1;
        position: absolute;
        width: 100%;
        margin: 0px;
        top: 0px;
        left: 0px;
        backface-visibility: hidden;
        -webkit-transform:translate3d(0,0,0);
        transform-style: preserve-3d;
        perspective: 1000;
    }
    .front-box {
        z-index: 2;
    }
    .back-box {
        z-index: 1;
        transform: rotateY(180deg);
        position: absolute;
        left: 0px;
    }
    &.rotate {
        transform: rotateY(180deg);
    }
    img.loyalty-ad {
        width: 100%;
        position: absolute;
    }
    .btns {
        position: absolute;
        top: 0px;
        left: 0px;
        transform-origin: 0px 0px;
        .btn { position: absolute; background-color: rgba(200,0,200,0); &:active { transform: translate(0px,0px) } }
        .type-qr img { width: 100%; }
        .type-link a { position: absolute; width: 100%; height: 100%; }
    }
}
</style>